import styled, { borderRadius, spacing } from "@rentiohq/web-theme";

export const Wrap = styled.div`
  margin-top: ${spacing("loose")};
  padding: ${spacing("loose")};
  border-radius: ${borderRadius("large")};
  background: ${({ theme }) => theme.colors.neutral10};
  border: 1px solid ${({ theme }) => theme.colors.neutral20};
`;

export const Header = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: ${spacing("base")};
  margin-bottom: ${spacing("extraTight")};
`;

export const Label = styled.div`
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.getColor("primary")};
`;

export const Question = styled.div`
  margin-bottom: ${spacing("base")};
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.neutral100};
`;

export const Options = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing("tight")};
`;

export const Option = styled.button<{ isRight: boolean; isWrong: boolean }>`
  display: flex;
  align-items: center;
  gap: ${spacing("tight")};
  width: 100%;
  padding: ${spacing("tight")} ${spacing("base")};
  border-radius: ${borderRadius("large")};
  border: 1px solid
    ${({ theme, isRight, isWrong }) => {
      if (isRight) {
        return theme.getColor("green", "800");
      }
      if (isWrong) {
        return theme.getColor("red", "800");
      }

      return theme.colors.neutral30;
    }};
  background: ${({ theme, isRight, isWrong }) => {
    if (isRight) {
      return theme.getColor("green", "0");
    }
    if (isWrong) {
      return theme.getColor("red", "0");
    }

    return theme.colors.neutral0;
  }};
  color: ${({ theme }) => theme.colors.neutral100};
  font-size: 15px;
  text-align: left;
  cursor: pointer;

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.getColor("primary")};
  }

  &:disabled {
    cursor: default;
  }
`;

const OPTION_LETTER_SIZE = "26px";

export const OptionLetter = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: ${OPTION_LETTER_SIZE};
  height: ${OPTION_LETTER_SIZE};
  border-radius: 50%;
  background: ${({ theme }) => theme.getColor("primary")};
  color: ${({ theme }) => theme.colors.neutral0};
  font-size: 13px;
  font-weight: 600;
`;

export const Feedback = styled.div<{ isCorrect: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${spacing("extraTight")};
  margin-top: ${spacing("base")};
  padding: ${spacing("base")};
  border-radius: ${borderRadius("large")};
  border-left: 4px solid
    ${({ theme, isCorrect }) =>
      isCorrect
        ? theme.getColor("green", "800")
        : theme.getColor("red", "800")};
  background: ${({ theme }) => theme.colors.neutral0};
  font-size: 15px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.neutral90};
`;

export const FeedbackTitle = styled.div`
  font-weight: 600;
  color: ${({ theme }) => theme.colors.neutral100};
`;
